var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "spinner spinner--mikepad", style: _vm.styles },
    [
      _c("div", { staticClass: "spinner-inner", style: _vm.innerStyles }, [
        _c("div", { staticClass: "binding" }),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pad" }, [
      _c("div", { staticClass: "line line1" }),
      _vm._v(" "),
      _c("div", { staticClass: "line line2" }),
      _vm._v(" "),
      _c("div", { staticClass: "line line3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }